import { FunctionComponent } from 'react';
import { useWindowDimensions, ViewStyle } from 'react-native';
import { Box, Breakpoint, getBreakpoint, Styles } from '@bonanza-social/moonlight';

const withLandscapeLock = <T extends object>(
  Component: FunctionComponent<T>,
) => {
  const EnhancedComponent = (props: T) => {
    const { width: windowWidth, height: windowHeight } = useWindowDimensions();
    const isLandscape =
      windowWidth > windowHeight &&
      getBreakpoint(windowHeight) === Breakpoint.MOBILE;
    const landScapeStyle: Styles<ViewStyle> = {
      flex: undefined,
      transform: 'rotate(-90deg)',
      width: windowHeight,
      height: windowWidth,
    };

    return (
      <Box flex={1} centerContent={isLandscape}>
        <Box flex={1} {...(isLandscape && landScapeStyle)}>
          <Component {...props} />
        </Box>
      </Box>
    );
  };

  return EnhancedComponent;
};

export default withLandscapeLock;
